import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { datatableActions, datatableSelectors } from './store'

const DatatableLimit = () => {
	const dispatch = useDispatch()
	const limit = useSelector(datatableSelectors.getLimit)
	const show = useSelector(datatableSelectors.getShowLimit)

	const handleChangeLimit = (e: React.ChangeEvent<{ value: any }>) => {
		dispatch(datatableActions.updateLimit({ limit: +e.target.value }))
		dispatch(datatableActions.getData())
	}

	if (!show) {
		return null
	}
	return (
		<div>
			<FormControl>
				<Select labelId="datatable-limit" id="datatable-limit" value={limit} onChange={handleChangeLimit}>
					<MenuItem value={10}>10</MenuItem>
					<MenuItem value={20}>20</MenuItem>
					<MenuItem value={50}>50</MenuItem>
					<MenuItem value={100}>100</MenuItem>
				</Select>
			</FormControl>
		</div>
	)
}

export default DatatableLimit
